import { Splide } from "@splidejs/splide";

const carousel = () => {
  // サイズの確認
  // const isMobile = window.innerWidth <= 768;
  // if (!isMobile) return;
  const targetElms = document.getElementsByClassName('js-InterviewCarousel');
  if(targetElms.length === 0) return;
  for(const targetElm of targetElms) {
    const speed = 1500;
    let options = {
      type: "slide",
      speed: speed,
      rewind: boolean = false,
      pauseOnFocus: boolean = false,
      pauseOnHover: boolean = false,
      autoWidth: true,
      drag: false,
      updateOnMove: true,
      arrows: false,
      pagination: false,
      reduceMotion: {
        speed: speed,
      },
    // SP時の設定（768px以下）
      breakpoints: {
        992: {
          drag: true,
          gap: "2rem",
        }
      }
    }

    const slider = new Splide(targetElm, options);
    const bar = slider.root.querySelector(".my-carousel-progress-bar");

    // Splideの初期化が終わった際、またはスライドが切り替わる際にバーの長さを更新する
    slider.on("mounted move", function () {
      const end = slider.Components.Controller.getEnd() + 1;
      const rate = Math.min((slider.index + 1) / end, 1);
      bar.style.width = String(100 * rate) + "%";
    });
    slider.mount();
  }
}
const init = () => {
  carousel();
}
export default init;